import cookies from 'js-cookie'

export default (drmEnabled = false, production = true) => {
  const nonDrm = {
    PLAYER_ID: 'giGQ2dt99',
    ACCOUNT_ID: '1486976045',
    AD_CONFIG_ID: 'c64b3f6c-d36a-44ce-92ea-e7a9a68d436d',
    CONFIG_ID: '1c027e5b-b4fe-41b9-b3bc-1a42cbf1f8a8',
    POLICY_KEY: 'BCpkADawqM1WJ12PwtUWqGXx3nbAo2XVSxyAQxPRZKBc75svhrUB9qIMPN_d9US0Vib5smumeNMbntSmZIpzeVV1iUrnzYgf5k7UMaVN46PGYe_oSZ-xbPVnsm4',
  }

  const drm = {
    PLAYER_ID: 'eMKeCsJC3',
    ACCOUNT_ID: '6204867266001',
    AD_CONFIG_ID: '7fb30a85-56ee-49f8-b645-900876e7c09c',
    CONFIG_ID: 'edbc4bd0-6a34-46f2-8055-45d823d66886',
    POLICY_KEY: 'BCpkADawqM1fQNUrQOvg-vTo4VGDTJ_lGjxp2zBSPcXJntYd5csQkjm7hBKviIVgfFoEJLW4_JPPsHUwXNEjZspbr3d1HqGDw2gUqGCBZ_9Y_BF7HJsh2n6PQcpL9b2kdbi103oXvmTNZWiQ',
  }

  if (!production) {
    nonDrm.PLAYER_ID = 'Djkuzp0eI'
    nonDrm.AD_CONFIG_ID = 'c7f7c873-212f-480f-b6fe-4971053e6cae'

    drm.PLAYER_ID = 'pX8yUVWvu'
    drm.AD_CONFIG_ID = 'c4e5fb3d-727e-49e4-8438-fe1fddf68bd9'

    if (cookies.get('FREEWHEEL_TEST_ENVIRONMENT') === 'true') {
      nonDrm.AD_CONFIG_ID = 'd1b3d682-02bb-4cf4-bf4c-3737bf75df89'
      drm.AD_CONFIG_ID = '52652941-442f-4e9b-a05f-770e1cbe5c46'
    }
  }

  return drmEnabled ? drm : nonDrm
}
